/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React, { useEffect } from "react";
import { Form } from "antd";
import BaseCreditBooking from "./BaseCreditBooking";
import { useParams } from "react-router-dom";
import API from "../../../api";
import urls from "../../../api/urls";
import { convertCurrentToPrevBookingData } from "../../../utils/bookingDataConverter";

const CPCreditBooking = (props) => {
  const { id } = useParams();
  const { GET_SINGEL_DOCUMENT_DETAILS_AWB_BE } = urls;

  const getDetails = async (id) => {
    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;
    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      let extract = response?.response?.data?.data?.items;
      let convert = convertCurrentToPrevBookingData(extract);
      return convert;
    }
    return null;
  };

  return (
    <BaseCreditBooking
      {...props}
      getDetails={getDetails}
      isClientAdmin={false}
    />
  );
};

export default CPCreditBooking;
